import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { settings } from '@pixi/core';
import { XMLFormat } from './XMLFormat.mjs';
var XMLStringFormat = /*#__PURE__*/function () {
  function XMLStringFormat() {
    _classCallCheck(this, XMLStringFormat);
  }
  _createClass(XMLStringFormat, null, [{
    key: "test",
    value: function test(data) {
      if (typeof data === "string" && data.includes("<font>")) {
        return XMLFormat.test(settings.ADAPTER.parseXML(data));
      }
      return false;
    }
  }, {
    key: "parse",
    value: function parse(xmlTxt) {
      return XMLFormat.parse(settings.ADAPTER.parseXML(xmlTxt));
    }
  }]);
  return XMLStringFormat;
}();
export { XMLStringFormat };